// WC – Price Rescue
// Cél: ha a product oldalon a price blokk csak "Regular price / Unavailable"
// szöveget mutat, akkor a Shopify publikus JSON endpointjáról (/products/handle.js)
// lehúzzuk a termékadatot, és kézzel beírjuk a variáns árát.

document.addEventListener('DOMContentLoaded', function () {
  // 1) Price konténer keresése
  var priceEl = document.querySelector(
    '.product__price, .product__price-wrapper, [data-product-price]'
  );
  if (!priceEl) return;

  var rawText = (priceEl.innerText || '').replace(/\s+/g, ' ').trim();
  var hasDigit = /\d/.test(rawText);
  var isUnavailable = /unavailable/i.test(rawText);

  // Ha már rendes ár van (számjegyek + nem csak "Unavailable"), nem nyúlunk hozzá
  if (hasDigit && !isUnavailable) return;

  // 2) Termék handle kiszedése az URL-ből: /collections/.../products/<handle>
  var m = window.location.pathname.match(/\/products\/([^\/]+)/);
  if (!m || !m[1]) return;
  var handle = m[1];

  // 3) Jelenlegi variáns ID a formból (ha van)
  var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
  var currentVariantId = idInput ? parseInt(idInput.value, 10) : null;

  // 4) Segédfüggvény: ár formázása cents-ből money_format alapján
  function formatPriceFromCents(cents) {
    var moneyFormat = null;

    try {
      if (window.Shopify && typeof Shopify.money_format === 'string' && Shopify.money_format.length) {
        moneyFormat = Shopify.money_format;
      } else if (window.theme && typeof theme.moneyFormat === 'string' && theme.moneyFormat.length) {
        moneyFormat = theme.moneyFormat;
      }
    } catch (e) {
      // ignore
    }

    if (!moneyFormat) {
      // fallback: dollár, ha nincs más infó
      moneyFormat = '${{amount}}';
    }

    var value = (cents / 100).toFixed(2);

    // A leggyakoribb tokeneket cseréljük ({{amount}}, {{ amount }})
    var formatted = moneyFormat;
    formatted = formatted.replace(/{{\s*amount\s*}}/g, value);

    // Ha valamiért nem volt benne token, legyen legalább "$39.90"
    if (!/\d/.test(formatted)) {
      formatted = '$' + value;
    }

    return formatted;
  }

  // 5) Termék JSON lehúzása
  fetch('/products/' + encodeURIComponent(handle) + '.js', {
    credentials: 'same-origin',
    cache: 'no-store'
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (product) {
      if (!product || !Array.isArray(product.variants) || !product.variants.length) {
        return;
      }

      var variant = null;

      if (currentVariantId) {
        variant = product.variants.find(function (v) {
          return v.id === currentVariantId;
        }) || null;
      }

      if (!variant) {
        variant = product.variants[0];
      }
      if (!variant) return;

      var cents = variant.price;
      var formatted = formatPriceFromCents(cents);

      // 6) Ár HTML felépítése – illeszkedjen a theme-hez
      var html =
        '<span class="price-item price-item--regular ff-product-price-amount">' +
        formatted +
        '</span>';

      priceEl.classList.remove('hide');
      priceEl.innerHTML = html;
    })
    .catch(function (err) {
      console.warn('[WC] Price Rescue – failed to fetch product JSON', err);
    });
});
